(ns frontend.ux-overhaul.nev.view
  (:require
   [frontend.ux-overhaul.nev.default-components :refer [render-nev-section]]
   [frontend.ux-overhaul.nev.oppo.components]
   [re-frame.core :as rf]
   [reagent.ratom :as ratom]
   [potpuri.core :as p :refer [fn->]]
   [common.localization :as loc]
   [common.util :as cu]
   [clojure.string :as string]
   [frontend.view.nev.events :as events]
   [common.entity :as entity]
   [frontend.view.not-found :as not-found]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.view.entity-viewers.utils :as entity-utils]
   [frontend.view.syncing-data :as syncing]
   [frontend.db :as app-db]
   [frontend.ux-overhaul.nev.components.nev-header :as nev-header]
   [frontend.view.entity-viewers.modules.risk.event :as risk-event]
   [frontend.actions.deal :as deal-actions]
   [frontend.view.nev.oppo.events :as oppo-events]
   [frontend.view.modals.ai-deal-one-pager.view :as ai-deal-one-pager]
   [frontend.view.modals.memo.view :as memo]
   [frontend.view.modals.events :as modals]
   [frontend.state.permissions :as f-permissions]
   [frontend.tenant-customizations :as tenant-customizations]
   [reagent.core :as r]
   [frontend.ux-overhaul.nev.oppo.configuration :as oppo-view-config]
   [frontend.ux-overhaul.components.modal.view]
   [frontend.ux-overhaul.nev.events]))

(def fees-associated-entities-attributes
  [:common/related-entities-company
   :common/related-entities-person])

(defn toolbar-buttons
  [{:keys [entity] :as _view-args}]
  (let [flagged? (contains? (:oppo/flagged-by entity)
                            (:db/id @session/account))]
    (->>
     (concat
      [(zap-toolbar/dropdown-button
        {:icon      :fa-star
         :on-select (partial deal-actions/toggle-flag entity flagged?)
         :ord       1
         :label     (loc/tr (if flagged? :unflag-deal-deal-menu-item :flag-deal-deal-menu-item))})]
      (when-not (session/is-read-only-user?)
        [(zap-toolbar/dropdown-button
          {:icon           :fa-ban
           :label          (loc/tr :pass)
           :ord            2
           :custom-style   "zap-btn__solid__salmon"
           :dropdown-color "salmon"
           :dropdown-action? (not= (:oppo/status entity) :oppo.status/passed)
           :on-select      (partial oppo-events/start-pass! entity)})
         (zap-toolbar/dropdown-button
          {:icon           :fa-pause
           :label          (loc/tr :put-on-hold)
           :ord            3
           :custom-style   "zap-btn__solid__yellow"
           :dropdown-color "yellow"
           :dropdown-action? (not= (:oppo/status entity) :oppo.status/on-hold)
           :on-select      (partial oppo-events/start-put-on-hold! entity)})
         (zap-toolbar/dropdown-button
          {:icon           :fa-redo-alt
           :label          (loc/tr :activate)
           :ord            4
           :custom-style   "zap-btn__solid__blue"
           :dropdown-color "blue"
           :dropdown-action? (not= (:oppo/status entity) :oppo.status/ok)
           :hidden?        (fn []
                             (not (some #{(:oppo/status entity)}
                                        [:oppo.status/on-hold :oppo.status/passed])))
           :on-select      #(oppo-events/resurrect! (:db/id entity))})])

      [(zap-toolbar/dropdown-button
        {:icon           :fa-check
         :label          (loc/tr :portfolio)
         :ord            5
         :custom-style   "zap-btn__solid__green"
         :dropdown-color "green"
         :dropdown-action? (not= (:oppo/status entity) :oppo.status/portfolio)
         :hidden?        (fn []
                           (some #{(:oppo/status entity)}
                                 [:oppo.status/portfolio :oppo.status/passed]))
         :on-select      #(oppo-events/start-to-portfolio! entity)})]

      (when-not (:common/disabled? entity)
        [(zap-toolbar/delete-button entity [:oppos-grid])])

      (when (f-permissions/field-write-access? :common/attachments
                                               (:entity/type entity)
                                               (:oppo/pipeline entity))
        [(zap-toolbar/dropdown-button {:on-select identity
                                       :divider   true
                                       :ord       20
                                       :label     (loc/tr :deal-secondary-menu-header-summaries)})
         (when (and (session/has-feature-access? :feature/ai-deal-parsing)
                    (not (session/is-read-only-user?)))
           (zap-toolbar/dropdown-button
            {:dropdown-action? true
             :icon :fa-robot
             :ord 24
             :on-select (fn []
                          (ai-deal-one-pager/open!
                           (:db/id entity)
                           (-> entity :oppo/pipeline :db/id)))
             :label (loc/tr :deal-one-pager/menu-item)}))
         (zap-toolbar/dropdown-button {:dropdown-action? true
                                       :icon      :fa-file-word
                                       :ord       23
                                       :on-select #(modals/open-modal! memo/modal-key
                                                                       {:oppo-id (:db/id entity)
                                                                        :skip-blank-values? true
                                                                        :full?   true})
                                       :label     (loc/tr :deal-menu-item-memorandum-full-no-blanks)})])
      [(zap-toolbar/dropdown-button
        {:dropdown-action? true
         :icon      :fa-file-word
         :ord       21
         :on-select #(modals/open-modal! memo/modal-key {:oppo-id (:db/id entity)})
         :label     (loc/tr :deal-menu-item-memorandum)})
       (zap-toolbar/dropdown-button {:dropdown-action? true
                                     :icon      :fa-file-word
                                     :ord       22
                                     :on-select #(modals/open-modal! memo/modal-key
                                                                     {:oppo-id (:db/id entity)
                                                                      :full?   true})
                                     :label     (loc/tr :deal-menu-item-memorandum-full)})
       (when (session/has-feature-access? :feature/pdf-memo)
         (zap-toolbar/dropdown-button
          {:dropdown-action? true
           :icon      :fa-file-pdf
           :ord       25
           :on-select #(routing/set-view! [:pdf-memo :id (:db/id entity)])
           :label     (loc/tr :deal-menu-item-pdf-memorandum)}))])
     (remove nil?))))

;; New stuff

(defn container
  [{:keys [view-config]
    :as   view-args}]
  (let [view-configuration (:configuration view-config)]
    [:div.entity__container
     {:style {:flex-grow      "2"
              :padding        "10px 20px"
              :height         "calc(100vh - 122px)"
              :overflow       "hidden"
              :overflow-y     "scroll"
              :display        "flex"
              :flex-direction "column"
              :gap            "30px"}}

     [:div
      {:style {:display        "flex"
               :flex-direction "column"
               :max-width      "1000px"
               :padding-bottom "50px"}}
      (->> view-configuration
           :sections
           (map-indexed (fn [index section]
                          ^{:key (str "nev-section-" index)}
                          (render-nev-section {:nev-section section
                                               :view-args   view-args})))
           (doall))]]))

(defn nav-link
  [_props]
  (let [state (r/atom {})]
    (fn [{:keys [nev-section/title nev-section/id]}
         expanded?]
      (let [hover? (:hover? @state)
            style (if expanded?
                    {:height          "50px"
                     :display         "flex"
                     :align-items     "center"
                     :padding-left    "20px"
                     :cursor          "pointer"
                     :text-decoration (when hover? "underline")}
                    {:height          "50px"
                     :display         "flex"
                     :align-items     "center"
                     :padding-left    "10px"
                     :cursor          "pointer"
                     :text-decoration (when hover? "underline")})]
        [:div
         {:on-click       (fn []
                            (if-let [element (.getElementById js/document (str id))]
                              (.scrollIntoView element)
                              (js/console.log "element not found!")))
          :on-mouse-enter #(swap! state assoc :hover? true)
          :on-mouse-leave #(swap! state dissoc :hover?)
          :style          style}
         [:i.fal.fa-info-circle.mr-2
          {:aria-hidden true}]

         (when expanded?
           title)]))))

(defn side-navigation
  [_args]
  (let [initial-state {:expanded? (< 700 (:width @app-db/window))}
        state-atom (r/atom initial-state)]
    (fn [args]
      (let [expanded? (:expanded? @state-atom)
            sections (-> args
                         :view-config
                         :configuration
                         :sections)]
        [:div
         {:style {:width        (if expanded?
                                  "200px"
                                  "50px")
                  :transition-duration "200ms"
                  :height       "100%"
                  :padding-top  "20px"
                  :border-right "1px solid rgb(191, 191, 191)"}}
         [:div
          {:style {:display         "flex"
                   :justify-content (if expanded?
                                      "end"
                                      "center")}}
          [:div
           {:on-click #(swap! state-atom assoc :expanded? (not expanded?))
            :style    {:cursor  "pointer"
                       :padding "0px 10px"}}
           (if expanded?
             [:i.fal.fa-arrow-alt-from-right]
             [:i.fal.fa-arrow-alt-from-left])]]

         (->> sections
              (map (fn [section]
                     ^{:key (:nev-section/id section)}
                     [nav-link section expanded?]))
              (doall))]))))

(defn component
  [{:keys [oppo-id] :as _view-args}]
  (let [state-atom (r/cursor app-db/app-state [:views :nev :oppo])
        temp-atom (r/cursor state-atom [:temp])
        view-state-atom (r/cursor state-atom [:view-state])
        error-atom (r/cursor state-atom [:error])
        notification-atom (r/cursor state-atom [:notification])
        entity-sort (fn-> entity/display-string string/lower-case)
        view-id :deal
        module-collapsed-path (fn [module-id]
                                [view-id :modules :module-config module-id :collapsed?])
        r-existing-guests (ratom/reaction
                           (->> @session/all-roles
                                (cu/only-entity :role/role :role/guest-buy-side)
                                (remove :common/disabled?)
                                (cu/only-entity :role/target oppo-id)
                                doall))
        entity-atom (r/cursor session/entities [oppo-id])
        oppo (get @session/entities oppo-id)
        original-pipeline-id (:oppo/pipeline oppo)]
    (entity-utils/reset-state! state-atom oppo-id)
    (r/create-class
     {:component-did-update
      (partial entity-utils/component-did-update
               :oppo-id
               (partial events/clear-errors! error-atom notification-atom))
      :component-did-mount
      (fn [_]
        ;; A new-grid account does not get the fees, tasks, decisions, guests and
        ;; associations of the deal from the sync. Always open the scope, as the
        ;; other NEVs do. Otherwise a deal that is in the session has no scope.
        (entity-utils/reset-state! state-atom oppo-id
                                   {:always-fetch? (session/new-grid-2023?)})
        (swap! session/selected-pipelines assoc
               :oppo-pipeline
               original-pipeline-id)
        (when (and (session/risks-access?)
                   (f-permissions/field-read-access? :oppo/risk-entities
                                                     :entity.type/oppo
                                                     original-pipeline-id))
          (rf/dispatch [::risk-event/load-risks oppo-id])))
      :component-will-unmount
      (fn [_]
        (events/clear-errors! error-atom notification-atom)
        (entity-utils/clear-state! state-atom))
      :reagent-render
      (fn [{:keys [oppo-id] :as view-args}]
        (let [oppo (get @session/entities oppo-id)
              original-pipeline-id (:oppo/pipeline oppo)
              capman-re? (tenant-customizations/capman-is-real-estate-pipeline?
                          original-pipeline-id)
              thuja-capital-management? (tenant-customizations/thuja-capital-management?)
              header-fields (cond capman-re?
                                  [:oppo/deal-description]
                                  thuja-capital-management?
                                  [:oppo/status-and-next-steps]
                                  :else
                                   ;; TODO: configuration for user
                                  [:oppo/case-note :oppo/status-and-next-steps])]
          (cond
            (or (:common/disabled? oppo)
                (:not-found @state-atom))
            [not-found/not-found-content]
            (:loading @state-atom)
            [syncing/view]
            :else
            (if (or (not oppo)
                    (:common/disabled? oppo))
              [:div " "]
              (let [tenant @session/tenant
                    existing-guests @r-existing-guests
                    view-args (merge view-args
                                     {:state-atom           state-atom
                                      :oppo                 oppo
                                      :view-id              view-id
                                      :original-pipeline-id original-pipeline-id
                                      :header-fields        header-fields
                                      :temp-atom            temp-atom
                                      :view-state-atom      view-state-atom
                                      :error-atom           error-atom
                                      :notification-atom    notification-atom
                                      :entity-atom          entity-atom
                                      :tenant               tenant
                                      :entity-sort          entity-sort
                                      :existing-guests      existing-guests
                                      :module-collapsed-path module-collapsed-path})]
                [:<>
                 [nev-header/view
                  {:state           state-atom
                   :label           (partial zap-toolbar/toolbar-back
                                             [:oppos-grid]
                                             (loc/tr :back-to/oppos-grid))
                   :actions         (toolbar-buttons (assoc view-args
                                                            :entity oppo))
                   :dropdown-toggle [:span (loc/tr :actions)
                                     [:i.fas.fa-angle-down.ml-2]]
                   :dropdown-toggle-class-name
                   "zap-button zap-button--primary-btn actions-dropdown"}
                  view-args]

                 [:div
                  {:style {:height     "calc(100vh - 122px)"
                           :max-height "100%"
                           :display    "flex"}}
                  [side-navigation view-args]
                  [container view-args]]])))))})))


(defn view
  [view-args]
  (let [view-config (cond-> oppo-view-config/default-view
                      (not (session/transaction-process?))
                      (update-in [:configuration :sections]
                                 (fn [sections]
                                   (remove (fn [section]
                                             (= :nev-section.type/oppo-transactions
                                                (:nev-section/type section)))
                                           sections))))
        view-args (assoc view-args :view-config view-config)]
    [component view-args]))
